export default __webpack_public_path__ + "static/media/BiraCarvalho_03.4e2e9855.jpg";